module.exports = __webpack_public_path__ + "img/icon_service_four.52a476fc.svg";